export const userloginDetails = () => {
  const UserDetails =
    JSON.parse(localStorage.getItem("admin")) ||
    JSON.parse(localStorage.getItem("emp")) ||
    JSON.parse(localStorage.getItem("reseller"));
  return UserDetails;
};
